<template>
  <div class="content-container">
    <div v-loading="tableLoading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        :auto-size-cell="true"
        dom-layout="scroll"
        class="agGrid"
        @refresh="onRefresh"
        @selectionChanged="onSelectRows"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        :disabled="!enableDelete"
        class="btn primary small outline"
        @click="deleteBfCode"
      >
        {{ $t('button.deleteCode') }}
      </button>
      <button
        :disabled="!enableEdit"
        class="btn primary small"
        @click="fnShowEditDialog"
      >
        {{ $t('button.modifyCode') }}
      </button>
      <button class="btn primary small" @click="fnShowAddDialog">
        {{ $t('button.addCode') }}
      </button>
    </div>

    <el-dialog
      :title="
        isEditDialog
          ? $t('dialog.titleBreakfastEdit')
          : $t('dialog.titleBreakfastAdd')
      "
      width="640px"
      top="10px"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      @close="onCloseDialog"
    >
      <!-- START FORM -->
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:20|no_special"
                  :name="$t('field.breakfastCode')"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('field.breakfastCode') }}
                    </div>
                    <input
                      v-model="formBreakfastCode.code"
                      :readonly="isEditDialog"
                      type="text"
                    />
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider rules="" :name="$t('field.hotel')">
                  <div class="das-form-input">
                    <div class="label">
                      {{ $t('field.hotel') }}
                    </div>
                    <el-select
                      v-model="formBreakfastCode.hotel_id"
                      filterable
                      clearable
                      :placeholder="$t('variables.select')"
                    >
                      <el-option
                        v-for="item in hotelOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      />
                    </el-select>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="max:20|integer|min_value:0"
                  :name="$t('field.adultPrice')"
                >
                  <div class="das-form-input">
                    <div class="label">
                      {{ $t('field.adultPrice') }}
                    </div>
                    <!-- <input
                      v-model.number="formBreakfastCode.adult_price"
                      v-numeric-only
                      type="number"
                      min="0"
                    /> -->
                    <VxCurrencyInput v-model="formBreakfastCode.adult_price" />
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="max:20|integer|min_value:0"
                  :name="$t('field.childPrice')"
                >
                  <div class="das-form-input">
                    <div class="label">
                      {{ $t('field.childPrice') }}
                    </div>
                    <VxCurrencyInput v-model="formBreakfastCode.child_price" />
                    <!-- <input
                      v-model.number="formBreakfastCode.child_price"
                      v-numeric-only
                      type="number"
                      min="0"
                      onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                    /> -->
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required"
                  :name="$t('field.transactionCode')"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('field.transactionCode') }}
                    </div>
                    <select-with-search-table
                      style="width: 100%"
                      index-field="id"
                      :search-fields="['code', 'description']"
                      :selected-index-field-value="
                        formBreakfastCode.trading_code_id
                      "
                      :rows="transactionOptions"
                      :columns="transactionOptionsCols"
                      :value="formBreakfastCode.trading_code_id"
                      :dropdown-width="400"
                      @selectionChanged="onSelectTransaction"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        <div>
                          <span
                            v-if="
                              selectedData?.code && selectedData?.description
                            "
                          >
                            {{ selectedData.code }} -
                            {{ selectedData.description }}
                          </span>
                        </div>
                      </template>
                    </select-with-search-table>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required"
                  :name="$t('field.subTransactionCode')"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('field.subTransactionCode') }}
                    </div>
                    <select-with-search-table
                      style="width: 100%"
                      index-field="id"
                      :search-fields="['code', 'description']"
                      :selected-index-field-value="
                        formBreakfastCode.sub_trading_code_id
                      "
                      :rows="subTransactionOptions"
                      :columns="subTransactionOptionsCols"
                      :value="formBreakfastCode.sub_trading_code_id"
                      :dropdown-width="400"
                      @selectionChanged="onSelectSubTransaction"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        <div>
                          <span
                            v-if="
                              selectedData?.code && selectedData?.description
                            "
                          >
                            {{ selectedData.code }} -
                            {{ selectedData.description }}
                          </span>
                        </div>
                      </template>
                    </select-with-search-table>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="max:255" :name="$t('field.desc')">
                  <div class="das-form-input">
                    <div class="label">
                      {{ $t('field.desc') }}
                    </div>
                    <textarea
                      v-model="formBreakfastCode.description"
                      style="width: 100%"
                      rows="3"
                    />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="checkbox-container">
                  <div class="checkbox-wrap">
                    <input
                      id="include_room_rate"
                      v-model="formBreakfastCode.include_room_rate"
                      type="checkbox"
                    />
                    <label for="include_room_rate">
                      {{ $t('field.notIncludingInRoomRate') }}
                    </label>
                  </div>
                  <div class="checkbox-wrap ml-10">
                    <input
                      id="tax_fee"
                      v-model="formBreakfastCode.tax_fee"
                      type="checkbox"
                    />
                    <label for="tax_fee">
                      {{ $t('field.includeTaxFee') }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
      <!-- END FORM -->

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small outline" @click="onCloseDialog">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEditDialog"
            class="btn primary small"
            @click="updateBfCode"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addBfCode">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */

import {
  getBreakfastCodeListApi,
  addBreakfastCodeApi,
  deleteBreakfastCodeApi,
  updateBreakfastCodeApi,
  getDetailBreakfastCodeApi
} from '@/api/Service_Policy/breakfastCode.js'
import { getTransactionListApi } from '@/api/Transaction/transaction.js'
import { getSubTransactionListApi } from '@/api/Transaction/subTransaction.js'
import { getAllHotelApi } from '@/api/configuration/common'
import { Message } from 'element-ui'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'

const getDefaultFormBreakfastCode = () => ({
  id: null,
  code: null,
  description: null,
  adult_price: 0,
  child_price: 0,
  trading_code_id: null,
  sub_trading_code_id: null,
  include_room_rate: null,
  tax_fee: null,
  hotel_id: null
})

export default {
  components: {
    CellRenderCheckboxReadonly
  },
  data() {
    return {
      tableLoading: false,
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,

      // FOR DISABLING BUTTONS
      enableEdit: false,
      enableDelete: false,

      isEditDialog: false,
      dialogFormVisible: false,
      searchParams: {
        // pageSize: 10,
        // pageNum: 1,
        // orderTp: "ASC",
      },
      formBreakfastCode: getDefaultFormBreakfastCode(),
      columns: [
        // {
        //   headerName: "",
        //   field: "index",
        //   minWidth: 60,
        //   maxWidth: 60,
        //   headerCheckboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   checkboxSelection: true,
        //   resizable: false,
        // },
        {
          headerName: this.$t('grid.column.breakfastCode'),
          field: 'code',
          tooltipField: 'code',
          // cellClass: "grid-cell-centered",
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description',
          // cellClass: "grid-cell-centered",
          minWidth: 200,
          tooltipField: 'description'
        },
        {
          headerName: this.$t('grid.column.adultPrice'),
          field: 'adult_price',
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.childPrice'),
          field: 'child_price',
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.notIncludingInRoomRate'),
          field: 'include_room_rate',
          cellRenderer: 'CellRenderCheckboxReadonly',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          // cellRenderer: (params) => {
          //   return `<input type="checkbox" ${params.value ? 'checked' : ''}></input>`
          // },
          minWidth: 240,
          maxWidth: 240
        },
        {
          headerName: this.$t('grid.column.transactionCode'),
          field: 'trading_code',
          tooltipField: 'trading_code',
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          maxWidth: 130
        },
        {
          headerName: this.$t('grid.column.subTransactionCode'),
          field: 'sub_trading_code',
          tooltipField: 'sub_trading_code',
          // cellClass: "grid-cell-centered",
          minWidth: 140,
          maxWidth: 140
        },
        {
          headerName: this.$t('grid.column.hotel'),
          field: 'hotel_name',
          tooltipField: 'hotel_name',
          // cellClass: "grid-cell-centered",
          minWidth: 140,
          maxWidth: 140
        }
        // {
        //   headerName: 'Mô tả',
        //   field: 'name',
        //   // cellRenderer: 'CellRenderTextInput',
        //   cellClass: 'grid-cell-centered'
        // }
      ],
      rows: [],

      transactionOptionsCols: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          width: 100,
          tooltipField: 'code'
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description',
          flex: 1,
          tooltipField: 'description'
          // cellClass: "grid-cell-centered",
        }
      ],
      subTransactionOptionsCols: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          width: 100,
          tooltipField: 'code'
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description',
          flex: 1,
          tooltipField: 'description'
          // cellClass: "grid-cell-centered",
        }
      ],

      // SELECT OPTIONS
      transactionOptions: [],
      subTransactionOptions: [],
      hotelOptions: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible
        ? null
        : setTimeout(() => {
            this.resetFormBreakfastCode()
          }, 500)
    }
  },

  async mounted() {
    await Promise.all([
      this.fnGetTransactionOptions(),
      this.fnGetHotelOptions()
    ])
    this.attachData()

    this.gridApi = this.$refs.agGrid.gridApi
  },
  methods: {
    async fnGetTransactionOptions() {
      try {
        const resData = await getTransactionListApi({
          transactionGroup: 1
        })
        this.transactionOptions = resData.data
      } catch (err) {
        console.log(err)
      }
    },

    async fnGetSubTransOptions(transactionId) {
      try {
        const resData = await getSubTransactionListApi({ transactionId })
        this.subTransactionOptions = resData.data
      } catch (err) {
        console.log(err)
      }
    },

    async fnGetHotelOptions(breakfastId = null) {
      try {
        const resData = await getAllHotelApi({
          isBf: true,
          breakfastId: breakfastId
        })
        this.hotelOptions = resData.data
      } catch (err) {
        console.log(err)
      }
    },

    onSelectTransaction(data) {
      if (data?.id !== null && data?.id !== undefined) {
        if (this.formBreakfastCode.trading_code_id !== data.id) {
          this.formBreakfastCode.sub_trading_code_id = null
        }
        this.fnGetSubTransOptions(data.id)
      } else {
        this.subTransactionOptions = []
        this.formBreakfastCode.sub_trading_code_id = null
      }

      this.formBreakfastCode.trading_code_id = data?.id ?? null
    },
    onSelectSubTransaction(data) {
      this.formBreakfastCode.sub_trading_code_id = data?.id ?? null
    },

    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    async attachData() {
      this.tableLoading = true
      await getBreakfastCodeListApi(this.searchParams)
        .then(res => {
          this.rows = res.data
          // this.totalPage = Math.ceil(res.total / this.searchParams.pageSize);
          // this.currentPage = res.data.length == 0 ? 0 : res.page_num;
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    async addBfCode() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return

      await addBreakfastCodeApi(this.formBreakfastCode)
        .then(res => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },
    async updateBfCode() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      await updateBreakfastCodeApi(this.formBreakfastCode)
        .then(res => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    async deleteBfCode() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectBreakfastCode')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteBreakfastCode'), {
          resolveText: 'OK',
          rejectText: 'Cancel',
          resolve: () => {
            deleteBreakfastCodeApi({
              id_list: id_list
            })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('successMsg.' + res.message)
                })
                this.attachData()
              })
              .catch(err => {
                this.$message({
                  type: 'error',
                  message: this.$t('errorMsg.' + err.response.data.message)
                })
              })
          }
        })
      }
    },

    onSelectRows(rows) {
      this.enableEdit = rows?.length == 1
      this.enableDelete = !!rows.length
    },

    // Fill data of rows to form
    // onDoubleClicked(rows) {
    //   this.titlePopup = "Sửa mã ăn sáng";
    //   this.isEditDialog = true;
    //   const rowData = rows[0];
    //   this.formBreakfastCode = { ...rowData };
    //   this.dialogFormVisible = true;

    //   // Get sub transactions data for select input's options
    //   this.fnGetSubTransOptions(rowData.transactionId);
    // },
    resetFormBreakfastCode() {
      this.formBreakfastCode = getDefaultFormBreakfastCode()
      this.subTransactionOptions = []
    },

    fnShowAddDialog() {
      this.isEditDialog = false
      this.dialogFormVisible = true
      this.fnGetHotelOptions()
    },

    fnShowEditDialog() {
      const selectedRow = this.gridApi.getSelectedRows()[0]
      this.fnGetSubTransOptions(selectedRow.transactionId)
      this.formBreakfastCode = { ...selectedRow }
      this.fnGetHotelOptions(this.formBreakfastCode.id)
      this.isEditDialog = true
      this.dialogFormVisible = true
    },
    onCloseDialog() {
      this.hotelOptions = []
      this.dialogFormVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
